<template>
  <button
    type="button"
    class="flex h-8 w-[30px] items-center justify-center rounded-lg text-lg transition-colors disabled:opacity-30"
    :class="active ? 'bg-[#1c4848] text-white' : 'text-[#1c4848]/70 hover:bg-[#1c4848]/5 hover:text-[#1c4848]'"
    :aria-label="label"
    :aria-pressed="active"
    :title="shortcut ? `${label} (${shortcut})` : label"
    :disabled="disabled"
    @mousedown.prevent
  >
    <iconify-icon :icon="icon" aria-hidden="true" />
  </button>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  icon: { type: String, required: true },
  active: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  shortcut: { type: String, default: '' },
});
</script>
